var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createToken, Lexer, CstParser, MismatchedTokenException, NotAllInputParsedException, NoViableAltException, } from 'chevrotain';
import * as baobab from '@data/baobab/baobab';
import { TagType } from '@common/api';
import { getCannonicalTagName } from '@data/tag/tagUtil';
var AdditionOperator = createToken({ name: 'AdditionOperator', pattern: Lexer.NA });
var MultiplicationOperator = createToken({ name: 'MultiplicationOperator', pattern: Lexer.NA });
var ComparisonOperator = createToken({ name: 'ComparisonOperator', pattern: Lexer.NA });
var Plus = createToken({ name: 'Plus', pattern: /\+/, categories: AdditionOperator });
var Minus = createToken({ name: 'Minus', pattern: /-/, categories: AdditionOperator });
var Multi = createToken({ name: 'Multi', pattern: /\*/, categories: MultiplicationOperator });
var Div = createToken({ name: 'Div', pattern: /\//, categories: MultiplicationOperator });
var YearDiv = createToken({ name: 'YearDiv', pattern: /\/\//, categories: MultiplicationOperator });
var GreaterThan = createToken({ name: 'GreaterThan', pattern: />/, categories: ComparisonOperator });
var WhiteSpace = createToken({ name: 'WhiteSpace', pattern: /\s+/, group: Lexer.SKIPPED });
var NumberLiteral = createToken({ name: 'NumberLiteral', pattern: /\d+(?:\.\d*)?/ });
var FlowReference = createToken({ name: 'FlowReference', pattern: /[#]\d+/ });
var ClusterReference = createToken({ name: 'ClusterReference', pattern: /[#]c\d+/ });
var LParen = createToken({ name: 'LParen', pattern: /\(/ });
var RParen = createToken({ name: 'RParen', pattern: /\)/ });
var Comma = createToken({ name: 'Comma', pattern: /,/ });
var Query = createToken({ name: 'Query', pattern: /query\(.+?\)/ });
var Identifier = createToken({ name: 'Identifier', pattern: /(?:[a-zA-ZčČćĆđĐšŠžŽ][\w čČćĆđĐšŠžŽ]*)|(?:".*?")/ });
export var allTokens = {
    WhiteSpace: WhiteSpace,
    Plus: Plus,
    Minus: Minus,
    Multi: Multi,
    YearDiv: YearDiv,
    Div: Div,
    LParen: LParen,
    RParen: RParen,
    GreaterThan: GreaterThan,
    NumberLiteral: NumberLiteral,
    FlowReference: FlowReference,
    ClusterReference: ClusterReference,
    AdditionOperator: AdditionOperator,
    MultiplicationOperator: MultiplicationOperator,
    ComparisonOperator: ComparisonOperator,
    Comma: Comma,
    Query: Query,
    Identifier: Identifier,
};
var FormulaParser = /** @class */ (function (_super) {
    __extends(FormulaParser, _super);
    function FormulaParser() {
        var _this = _super.call(this, Object.values(allTokens), {
            recoveryEnabled: true,
        }) || this;
        _this.expression = _this.RULE('expression', function () {
            return _this.SUBRULE(_this.additionExpression);
        });
        _this.additionExpression = _this.RULE('additionExpression', function () {
            _this.SUBRULE(_this.multiplicationExpression, { LABEL: 'lhs' });
            _this.MANY(function () {
                _this.CONSUME(AdditionOperator);
                _this.SUBRULE2(_this.multiplicationExpression, { LABEL: 'rhs' });
            });
        });
        _this.multiplicationExpression = _this.RULE('multiplicationExpression', function () {
            _this.SUBRULE(_this.atomicWithOptionalUnaryMinus, { LABEL: 'lhs' });
            _this.MANY(function () {
                _this.CONSUME(MultiplicationOperator);
                _this.SUBRULE2(_this.atomicWithOptionalUnaryMinus, { LABEL: 'rhs' });
            });
        });
        _this.atomicWithOptionalUnaryMinus = _this.RULE('atomicWithOptionalUnaryMinus', function () {
            _this.OPTION(function () {
                _this.CONSUME(Minus);
            });
            _this.SUBRULE(_this.atomicExpression);
        });
        _this.atomicExpression = _this.RULE('atomicExpression', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.parenthesisExpression); } },
                { ALT: function () { return _this.CONSUME(Query); } },
                { ALT: function () { return _this.SUBRULE(_this.functionCall); } },
                { ALT: function () { return _this.CONSUME(NumberLiteral); } },
                { ALT: function () { return _this.CONSUME(FlowReference); } },
                { ALT: function () { return _this.CONSUME(ClusterReference); } },
                { ALT: function () { return _this.SUBRULE(_this.tagPath); } },
            ]);
        });
        _this.parenthesisExpression = _this.RULE('parenthesisExpression', function () {
            _this.CONSUME(LParen);
            _this.SUBRULE(_this.expression);
            _this.CONSUME(RParen);
        });
        _this.functionCall = _this.RULE('functionCall', function () {
            _this.CONSUME(Identifier);
            _this.CONSUME(LParen);
            _this.MANY_SEP({
                SEP: Comma,
                DEF: function () {
                    _this.SUBRULE(_this.expression);
                },
            });
            _this.CONSUME(RParen);
        });
        _this.tagPath = _this.RULE('tagPath', function () {
            _this.AT_LEAST_ONE_SEP({
                SEP: GreaterThan,
                DEF: function () {
                    _this.CONSUME(Identifier);
                },
            });
        });
        _this.performSelfAnalysis();
        return _this;
    }
    return FormulaParser;
}(CstParser));
var formulaParser = new FormulaParser();
var formulaLexer = new Lexer(Object.values(allTokens));
var BaseCstVisitor = formulaParser.getBaseCstVisitorConstructor();
var SemanticAnnotationVisitor = /** @class */ (function (_super) {
    __extends(SemanticAnnotationVisitor, _super);
    function SemanticAnnotationVisitor() {
        var _this = _super.call(this) || this;
        _this.validateVisitor();
        return _this;
    }
    SemanticAnnotationVisitor.prototype.expression = function (ctx, context) {
        return this.visit(ctx.additionExpression, context);
    };
    SemanticAnnotationVisitor.prototype.additionExpression = function (ctx, context) {
        var _this = this;
        var annotatedTokens = this.visit(ctx.lhs, context);
        this.visit(ctx.lhs, context);
        if (ctx.rhs) {
            ctx.rhs.forEach(function (rhsOperand, idx) {
                var operator = ctx.AdditionOperator[idx];
                annotatedTokens.push({
                    image: operator.image,
                    startOffset: operator.startOffset,
                    endOffset: operator.endOffset,
                    tokenType: operator.tokenType.name,
                    tokenAnnotationType: 'operator',
                });
                annotatedTokens = annotatedTokens.concat(_this.visit(rhsOperand, context));
            });
        }
        return annotatedTokens;
    };
    SemanticAnnotationVisitor.prototype.multiplicationExpression = function (ctx, context) {
        var _this = this;
        var annotatedTokens = this.visit(ctx.lhs, context);
        // "rhs" key may be undefined as the grammar defines it as optional (MANY === zero or more).
        if (ctx.rhs) {
            ctx.rhs.forEach(function (rhsOperand, idx) {
                // there will be one operator for each rhs operand
                var operator = ctx.MultiplicationOperator[idx];
                annotatedTokens.push({
                    image: operator.image,
                    startOffset: operator.startOffset,
                    endOffset: operator.endOffset,
                    tokenType: operator.tokenType.name,
                    tokenAnnotationType: 'operator',
                });
                annotatedTokens = annotatedTokens.concat(_this.visit(rhsOperand, context));
            });
        }
        return annotatedTokens;
    };
    SemanticAnnotationVisitor.prototype.atomicWithOptionalUnaryMinus = function (ctx, context) {
        var annotatedTokens = [];
        if (ctx.Minus && ctx.Minus.length > 0) {
            annotatedTokens.push({
                image: ctx.Minus[0].image,
                startOffset: ctx.Minus[0].startOffset,
                endOffset: ctx.Minus[0].endOffset,
                tokenType: ctx.Minus[0].tokenType.name,
                tokenAnnotationType: 'operator',
            });
        }
        if (ctx.atomicExpression) {
            annotatedTokens = annotatedTokens.concat(this.visit(ctx.atomicExpression, context));
        }
        return annotatedTokens;
    };
    SemanticAnnotationVisitor.prototype.atomicExpression = function (ctx, context) {
        if (ctx.parenthesisExpression) {
            return this.visit(ctx.parenthesisExpression, context);
        }
        else if (ctx.FlowReference) {
            var flo = ctx.FlowReference[0].image;
            var floId = parseInt(flo.substring(1));
            var tok = {
                image: flo,
                startOffset: ctx.FlowReference[0].startOffset,
                endOffset: ctx.FlowReference[0].endOffset,
                tokenType: ctx.FlowReference[0].tokenType.name,
                tokenAnnotationType: 'reference',
            };
            if (!context.flowMap[floId]) {
                tok.error = 'Nonexistent flow';
            }
            return [tok];
        }
        else if (ctx.ClusterReference) {
            var cls = ctx.ClusterReference[0].image;
            var clusterId = parseInt(cls.substring(2));
            var tok = {
                image: cls,
                startOffset: ctx.ClusterReference[0].startOffset,
                endOffset: ctx.ClusterReference[0].endOffset,
                tokenType: ctx.ClusterReference[0].tokenType.name,
                tokenAnnotationType: 'reference',
            };
            if (!context.clusterMap[clusterId]) {
                tok.error = 'Nonexistent cluster';
            }
            return [tok];
        }
        else if (ctx.NumberLiteral) {
            var nmbr = Number(ctx.NumberLiteral[0].image);
            var tok = {
                image: ctx.NumberLiteral[0].image,
                startOffset: ctx.NumberLiteral[0].startOffset,
                endOffset: ctx.NumberLiteral[0].endOffset,
                tokenType: ctx.NumberLiteral[0].tokenType.name,
                tokenAnnotationType: 'number',
            };
            return [tok];
        }
        else if (ctx.functionCall) {
            return this.visit(ctx.functionCall, context);
        }
        else if (ctx.Query) {
            var q = ctx.Query[0].image;
            var args = q.replace('query(', '').replace(')', '');
            var splat = args.split(',');
            // check if query expr is good
            var tok = {
                image: ctx.Query[0].image,
                startOffset: ctx.Query[0].startOffset,
                endOffset: ctx.Query[0].endOffset,
                tokenType: ctx.Query[0].tokenType.name,
                tokenAnnotationType: 'query',
            };
            return [tok];
        }
        else if (ctx.tagPath) {
            return this.visit(ctx.tagPath, context);
        }
        else {
            return [];
        }
    };
    SemanticAnnotationVisitor.prototype.parenthesisExpression = function (ctx, context) {
        return this.visit(ctx.expression, context);
    };
    SemanticAnnotationVisitor.prototype.functionCall = function (ctx, context) {
        var e_1, _a;
        var fnName = ctx.Identifier[0].image.toString();
        var annotatedTokens = [];
        annotatedTokens.push({
            image: ctx.Identifier[0].image,
            startOffset: ctx.Identifier[0].startOffset,
            endOffset: ctx.Identifier[0].endOffset,
            tokenType: ctx.Identifier[0].tokenType.name,
            tokenAnnotationType: 'function',
        });
        if (!functions.has(fnName)) {
            annotatedTokens[annotatedTokens.length - 1].error = 'Nonexistent function';
        }
        if (ctx.LParen && ctx.LParen.length > 0) {
            annotatedTokens.push({
                image: ctx.LParen[0].image,
                startOffset: ctx.LParen[0].startOffset,
                endOffset: ctx.LParen[0].endOffset,
                tokenType: ctx.LParen[0].tokenType.name,
                tokenAnnotationType: 'paren',
            });
        }
        var commas = ctx.Comma && ctx.Comma.length > 0 ? __spreadArray([], __read(ctx.Comma), false) : [];
        if (ctx.expression) {
            try {
                for (var _b = __values(ctx.expression), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var expr = _c.value;
                    annotatedTokens = annotatedTokens.concat(this.visit(expr, context));
                    if (commas.length > 0) {
                        var comma = commas.shift();
                        annotatedTokens.push({
                            image: comma.image,
                            startOffset: comma.startOffset,
                            endOffset: comma.endOffset,
                            tokenType: comma.tokenType.name,
                            tokenAnnotationType: 'comma',
                        });
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (ctx.RParen && ctx.RParen.length > 0) {
            annotatedTokens.push({
                image: ctx.RParen[0].image,
                startOffset: ctx.RParen[0].startOffset,
                endOffset: ctx.RParen[0].endOffset,
                tokenType: ctx.RParen[0].tokenType.name,
                tokenAnnotationType: 'paren',
            });
        }
        return annotatedTokens;
    };
    SemanticAnnotationVisitor.prototype.tagPath = function (ctx, context) {
        var e_2, _a;
        var annotatedTokens = [];
        var greaterThans = ctx.GreaterThan && ctx.GreaterThan.length > 0 ? __spreadArray([], __read(ctx.GreaterThan), false) : [];
        var tagp = [];
        try {
            for (var _b = __values(ctx.Identifier), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tagSegmentIdentifier = _c.value;
                var tagName = getCannonicalTagName(tagSegmentIdentifier.image);
                tagp.push(tagName);
                var tag = context.tagData.getTagByPath(tagp);
                var suffix = tag ? (tag.type === TagType.Account ? '-acc-tag' : '-tag') : '';
                var tok = {
                    image: tagSegmentIdentifier.image,
                    startOffset: tagSegmentIdentifier.startOffset,
                    endOffset: tagSegmentIdentifier.endOffset,
                    tokenType: tagSegmentIdentifier.tokenType.name,
                    tokenAnnotationType: 'reference' + suffix,
                    tag: tag,
                };
                if (!tag) {
                    tok.error = 'Nonexistent tag';
                }
                annotatedTokens.push(tok);
                if (greaterThans.length > 0) {
                    var gt = greaterThans.shift();
                    annotatedTokens.push({
                        image: gt.image,
                        startOffset: gt.startOffset,
                        endOffset: gt.endOffset,
                        tokenType: gt.tokenType.name,
                        tokenAnnotationType: 'greater-than',
                    });
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return annotatedTokens;
    };
    return SemanticAnnotationVisitor;
}(BaseCstVisitor));
var semanticAnnotationVisitor = new SemanticAnnotationVisitor();
var functions = new Set();
functions.add('delay');
functions.add('spread');
functions.add('floor');
functions.add('sum');
functions.add('cumsum');
functions.add('max');
functions.add('min');
functions.add('abs');
functions.add('round');
functions.add('eq');
functions.add('gt');
functions.add('gte');
functions.add('lt');
functions.add('lte');
functions.add('hasTags');
functions.add('hasValue');
functions.add('currentDate');
functions.add('if');
functions.add('and');
functions.add('or');
functions.add('not');
functions.add('mom');
functions.add('qoq');
functions.add('yoy');
functions.add('power');
functions.add('currentYear');
functions.add('currentMonth');
functions.add('daysInCurrentMonth');
functions.add('day');
functions.add('month');
functions.add('year');
functions.add('date');
functions.add('edate');
functions.add('predictAverage');
functions.add('avg');
export function tokenize(expression) {
    var lexingResult = formulaLexer.tokenize(expression);
    return lexingResult.tokens;
}
export function checkExpression(expression, tagData, sheetRowsById) {
    var clusterMap = sheetRowsById;
    var flowMap = baobab.root.get('f', 'flowsById');
    var errors = [];
    var lexingResult = formulaLexer.tokenize(expression);
    if (lexingResult.errors && lexingResult.errors.length > 0) {
        lexingResult.errors.forEach(function (err) {
            if (err.message.includes('unexpected')) {
                var token = expression.substring(err.offset, err.offset + err.length);
                errors.push({
                    start: err.offset,
                    end: err.offset + err.length,
                    message: 'Unexpected',
                    token: token,
                    errType: 'Lexing error',
                });
            }
            else {
                errors.push({
                    start: err.offset,
                    end: err.offset + err.length,
                    message: err.message,
                    token: '',
                    errType: 'Lexing error',
                });
            }
        });
    }
    formulaParser.input = lexingResult.tokens;
    var cst = formulaParser.expression();
    if (formulaParser.errors && formulaParser.errors.length > 0) {
        formulaParser.errors.forEach(function (err) {
            var start = -1;
            var end = -1;
            var token = '';
            var message = 'Syntax error';
            var errInstanceOf = '';
            if (err instanceof MismatchedTokenException) {
                if (err.token.image && err.token.image !== '') {
                    start = err.token.startOffset ? err.token.startOffset : -1;
                    end = err.token.endOffset ? err.token.endOffset : -1;
                    token = err.token.image;
                    message = 'Invalid syntax for';
                }
                else {
                    start = err.previousToken.startOffset ? err.previousToken.startOffset : -1;
                    end = err.previousToken.endOffset ? err.previousToken.endOffset : -1;
                    token = err.previousToken.image;
                    message = 'Missing token after';
                }
                errInstanceOf = 'MismatchedTokenException';
            }
            else if (err instanceof NoViableAltException) {
                if (err.token.image && err.token.image !== '') {
                    start = err.token.startOffset ? err.token.startOffset : -1;
                    end = err.token.endOffset ? err.token.endOffset : -1;
                    token = err.token.image;
                    message = 'Invalid syntax for';
                }
                else {
                    start = err.previousToken.startOffset ? err.previousToken.startOffset : -1;
                    end = err.previousToken.endOffset ? err.previousToken.endOffset : -1;
                    token = err.previousToken.image;
                    message = 'Missing token after';
                }
                errInstanceOf = 'NoViableAltException';
            }
            else if (err instanceof NotAllInputParsedException) {
                start = err.token.startOffset ? err.token.startOffset : -1;
                end = err.token.endOffset ? err.token.endOffset : -1;
                token = err.token.image;
                message = 'Unnecessary';
                errInstanceOf = 'NotAllInputParsedException';
            }
            errors.push({
                start: start,
                end: end,
                token: token,
                message: message,
                errInstanceOf: errInstanceOf,
                errType: 'Syntax error',
            });
        });
    }
    var cgcontext = {
        flowMap: flowMap,
        clusterMap: clusterMap,
        tagData: tagData,
    };
    try {
        var res = semanticAnnotationVisitor.visit(cst, cgcontext);
        res.forEach(function (tok) {
            if (tok.error) {
                errors.push({
                    start: tok.startOffset,
                    end: tok.endOffset,
                    token: tok.image,
                    message: tok.error,
                    errType: 'Semantic error',
                });
            }
        });
        return { tokens: res, errors: errors };
    }
    catch (e) {
        console.log('expression: ', expression);
        console.log('code generator error', e);
    }
    return { tokens: [], errors: errors };
}
